module.exports = __webpack_public_path__ + "img/sld_mfm_t1_b1_black.4ae3632e.svg";